import { Instance } from 'mobx-state-tree';
import { CreateOrdersFromCustomersResultDtoModelBase } from './CreateOrdersFromCustomersResultDtoModel.base';

/* The TypeScript type of an instance of CreateOrdersFromCustomersResultDtoModel */
export interface CreateOrdersFromCustomersResultDtoModelType extends Instance<typeof CreateOrdersFromCustomersResultDtoModel.Type> {}

/* A graphql query fragment builders for CreateOrdersFromCustomersResultDtoModel */
export { selectFromCreateOrdersFromCustomersResultDto, createOrdersFromCustomersResultDtoModelPrimitives, CreateOrdersFromCustomersResultDtoModelSelector } from './CreateOrdersFromCustomersResultDtoModel.base';

/**
 * CreateOrdersFromCustomersResultDtoModel
 */
export const CreateOrdersFromCustomersResultDtoModel = CreateOrdersFromCustomersResultDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
